import * as React from "react";
import { IconProps } from "./IconProps";

export const IconError = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="CellStatus [ARCHIVED]">
          <path
            id="Union"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.66341 7.99667C2.66341 5.05115 5.05123 2.66334 7.99675 2.66334C10.9423 2.66334 13.3301 5.05115 13.3301 7.99667C13.3301 10.9422 10.9423 13.33 7.99675 13.33C5.05123 13.33 2.66341 10.9422 2.66341 7.99667ZM7.99675 1.33C4.31485 1.33 1.33008 4.31477 1.33008 7.99667C1.33008 11.6786 4.31485 14.6633 7.99675 14.6633C11.6786 14.6633 14.6634 11.6786 14.6634 7.99667C14.6634 4.31477 11.6786 1.33 7.99675 1.33ZM8.92231 5.00118C8.96248 4.45847 8.53299 3.99602 7.98879 3.99602C7.45045 3.99602 7.02305 4.449 7.0543 4.98643L7.26181 8.55472C7.28334 8.92485 7.58976 9.21397 7.96051 9.21397C8.327 9.21397 8.63142 8.93124 8.65847 8.56575L8.92231 5.00118ZM7.28636 11.7268C7.47946 11.9063 7.71854 11.996 8.0036 11.996C8.27946 11.996 8.51395 11.9063 8.70705 11.7268C8.90015 11.5473 8.9967 11.3251 8.9967 11.0601C8.9967 10.7952 8.90015 10.5729 8.70705 10.3935C8.51395 10.214 8.27946 10.1242 8.0036 10.1242C7.71854 10.1242 7.47946 10.214 7.28636 10.3935C7.09326 10.5729 6.9967 10.7952 6.9967 11.0601C6.9967 11.3251 7.09326 11.5473 7.28636 11.7268Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
